import { S } from '../core/game';
import { toast } from '../core/effects';
import { m } from '../i18n';
import { sfx } from '../audio/sfx';
import { say, type Choice } from '../ui/dialog';
import { getObject } from '../world/map';
import type { World } from '../world/world';

/** Line 8 runs along the main street, west to east. */
export const BUS_STOPS = ['busStopW', 'busStop', 'busStopE'] as const;
export type BusStopId = (typeof BUS_STOPS)[number];

const FIRST_BUS = 6 * 60;
const LAST_BUS = 22 * 60;

let world: World | null = null;
export function bindBusWorld(w: World): void {
  world = w;
}

/** Where you wait (and get off): on the kerb in front of the shelter. */
export function stopPoint(id: BusStopId): { x: number; y: number } {
  const r = getObject(id)!.rect;
  return { x: r.x + r.w / 2, y: r.y + r.h + 6 };
}

export function openBusStop(here: BusStopId): void {
  const t = m().busStop;
  const who = m().objects.busStop;
  const time = S().time % (24 * 60);
  if (time < FIRST_BUS || time >= LAST_BUS) return say({ who, icon: '🌙', text: t.night });
  const choices: Choice[] = BUS_STOPS.map((id) =>
    id === here
      ? { text: `${t.here}: ${t.stops[id]}`, disabled: true }
      : {
          text: `🚌 ${t.stops[id]}`,
          run: () => {
            sfx('click');
            toast(t.beep);
            world?.takeBus(stopPoint(here), stopPoint(id), () => {
              sfx('ok');
              toast(t.arrived(t.stops[id]));
            });
          },
        },
  );
  choices.push({ text: t.notNow });
  say({ who, icon: '🚏', text: t.where, choices });
}
